export default __webpack_public_path__ + "static/media/webmilesCoin.e2a80891.svg";